import { render, staticRenderFns } from "./EditorPhones.vue?vue&type=template&id=58ea09eb&scoped=true&"
import script from "./EditorPhones.vue?vue&type=script&lang=js&"
export * from "./EditorPhones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea09eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ea09eb')) {
      api.createRecord('58ea09eb', component.options)
    } else {
      api.reload('58ea09eb', component.options)
    }
    module.hot.accept("./EditorPhones.vue?vue&type=template&id=58ea09eb&scoped=true&", function () {
      api.rerender('58ea09eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/myaccount/editors/EditorPhones.vue"
export default component.exports